import React, {RefObject} from "react";
import {getTranslate, Translate, TranslateFunction} from "react-localize-redux";
import "./ErrorPage.scss";
import {connect} from "react-redux";
import StoreState from "../../interfaces/store/storeState";
import CommonView from "../CommonView/CommonView";

interface StateProps {
    translate: TranslateFunction
}

type Props = StateProps;

class ErrorPage extends React.Component<Props> {
    private static readonly translatePath: string = "pages.ErrorPage";

    private messageRef: RefObject<HTMLSpanElement> = React.createRef();

    constructor(props: Props) {
        super(props);

        this.focusMessage = this.focusMessage.bind(this);
    }

    /**
     * Skip link for error page
     *
     * @return {void}
     */
    focusMessage(): void {
        this.messageRef.current?.focus();
    }

    render() {
        const {translatePath}: typeof ErrorPage = ErrorPage;
        return (
            <CommonView className="df-error-page-404" focusMainContent={this.focusMessage}>
                <div className="df-error-404">
                    <div className="df-error-img-404"/>
                    <div className="df-error-text-404">
                        <p>
                            <Translate id={`${translatePath}.404.text`}/>
                        </p>
                        <p>
                            <Translate id={`${translatePath}.pageNotFound.text`}/>
                        </p>
                        <p>
                            <Translate id={`${translatePath}.instruction.text`}/>
                        </p>
                    </div>
                </div>
            </CommonView>
        );
    }
}

function mapStateToProps(state: StoreState): StateProps {
    return {
        translate: getTranslate(state.localize),
    };
}

export default connect(mapStateToProps)(ErrorPage);
